import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ApiError } from "./core/api/apiTypes";
import "./core/appVersion";
import { AppErrorBoundary } from "./core/telemetry/AppErrorBoundary";
import { installClickTelemetry } from "./core/telemetry/clickTelemetry";
import { createTelemetryCaches } from "./core/telemetry/queryTelemetry";
import { reactRootErrorHandlers } from "./core/telemetry/reactErrorHandlers";
import { initTelemetry } from "./core/telemetry/telemetry";
import App from "./App.tsx";

// Start before rendering so startup crashes are reported.
initTelemetry();
installClickTelemetry();

// Enable dark mode
// document.documentElement.classList.add("dark");

// Create a query client with default options
const queryClient = new QueryClient({
  ...createTelemetryCaches(),
  defaultOptions: {
    queries: {
      // Client errors (validation, auth, not found) won't succeed on retry.
      retry: (failureCount, error) =>
        failureCount < 1 && !(error instanceof ApiError && error.Status >= 400 && error.Status < 500 && error.Status !== 408 && error.Status !== 429),
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000, // 30 seconds
    },
    mutations: {
      retry: 0,
    },
  },
});

createRoot(document.getElementById("root")!, reactRootErrorHandlers).render(
  <StrictMode>
    <AppErrorBoundary scope="app">
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AppErrorBoundary>
  </StrictMode>
);
